import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  BASE_URL,
  calculateAge,
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import { REG_LOCATION } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { dateFormatter } from '../../../../../utils';
import axios from 'axios';

const STATUS_TABLE_HEADER = [
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },

  {
    header: 'Gender',
    accessor: 'gender'
  },
  {
    header: 'Age',
    accessor: (row) => calculateAge(row?.dob)
  },

  {
    header: 'Mobile No.',
    accessor: 'mobile'
  },
  {
    header: 'Doctor',
    accessor: (row) => row?.doctor?.name
  },
  {
    header: 'App No.',
    accessor: (row) => row?.app_no
  },
  {
    header: 'App Date',
    accessor: (row) => `${formatDate(row?.date)} ${row?.time}`
  },
  {
    header: 'Location',
    accessor: 'location'
  },
  {
    header: 'Service',
    accessor: 'service'
  }
];

const initialStatusDataObj = {
  data: [],
  loading: false
};

export const AppointmentStatus = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [statusDataObj, setStatusDataObj] = useState(initialStatusDataObj);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const user = localStorage.getItem("user");
  const userDetail = JSON.parse(user)

 

  const { getValues } = useForm();

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {},
    mode: 'all'
  });
  const { handleSubmit, reset, setValue } = methods;

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('doctor')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      if (defaultState) {
        console.log('Setting default doctor:', defaultState._id);
        setValue('doctor', defaultState._id);
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown();
    getDepartmentDropdown();
  }, [getDepartmentDropdown, getDepartmentDropdown]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const fetchData = async () => {
    try {
      const response = await request('/appointment-not-authorise', { method: 'GET' });
      if (response.success) {
        const fromDate = methods.getValues('from_date');
        const toDate = methods.getValues('to_date');
        const selectedDoctor = methods.getValues('doctor');
        const selectedDepartment = methods.getValues('department');
        const selectedLocation = methods.getValues('location');
        let filteredData = response.data.filter((appointment) => appointment.authorize === false);
        filteredData = filteredData.filter((appointment) => {
          const matchesDoctor = !selectedDoctor || appointment.doctor._id === selectedDoctor;
          const matchesDepartment = !selectedDepartment || appointment.department === selectedDepartment;
          const matchesLocation = !selectedLocation || appointment.location === selectedLocation;
          return matchesDoctor && matchesDepartment && matchesLocation;
        });
        const dateFilteredData = filterData(filteredData, fromDate, toDate);
        setStatusDataObj({
          loading: false,
          data: dateFilteredData.sort((a, b) => b.app_no - a.app_no)
        });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setStatusDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setStatusDataObj({ loading: false });
    }
  };

  const filterData = (data, fromDate, toDate) => {
    let filteredData = [...data];
    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(23, 59, 59, 999);
      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.date).getTime();
        return createdAt >= from && createdAt <= to;
      });
    }
    console.log('After date filter:', filteredData);
    return filteredData;
  };

  useEffect(() => {
    fetchData();
  }, [
    methods.watch('from_date'),
    methods.watch('to_date'),
    methods.watch('doctor'),
    methods.watch('department'),
    methods.watch('location')
  ]);

  const handleAuthorize = async (row) => {
    setLoading(true);
    try {
      const response = await request('/appointment-authorize', {
        method: 'PUT',
        params: row.app_no
      });
      if (response?.success) {
//         try {
//           const message = `Dear ${response?.data.patient_name},
// Appointment No. ${response?.data.app_no}
// Welcome to ${userDetail.nameOfOrg}.
// We are honored that you have chosen us for your healthcare needs.
// We wish you a smooth and speedy recovery and are here to support you every step of the way.
// Warm regards,
// The ${userDetail.nameOfOrg} Team`;
//           const responsee = axios.post(`${BASE_URL}/proxy/send`, {
//             number: `${response.data.mobile}`,
//             type: 'text',
//             message: encodeURIComponent(message)
//           });
//         } catch (error) {
//           console.log(error);
//         }
        toast('Successfully authorized appointment', { variant: 'success' });
        setSelectedRecord(response.data);
        setCurrentAction();
        await fetchData();
      }
    } catch (error) {
      console.log(error);
      toast('An error occurred while authorizing appointment', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(handleAuthorize)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Appointment Update Status
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn id={'Submit'} variant="contained">
                  Confirmed
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment} Print`} variant="contained">
                  cancel
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={2} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                    <SelectTag formControlSX={{ flex: 0.8 }} name="location" menus={REG_LOCATION} />
                  </Stack>
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="doctor"
                      menus={doctorDropdown}
                      onChange={({ target: { row } }) => {
                        setValue('department', row.qualification_details.department);
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="department"
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={5} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="from_date" type="date" />
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="to_date" type="date" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, border: '0px solid gray' }}>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                      data={statusDataObj.data}
                      columns={STATUS_TABLE_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        setSelectedRecord(row);
                      }}
                      showAuthorize={true}
                      onAuthorizeHandler={(row) => handleAuthorize(row)}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
